import { createActions, } from 'redux-actions';

export const { statistics, } = createActions({
  STATISTICS: {
    SET: null,
    RESET: null,
  },
});
